<template>
  <v-btn :block="block" :small="small" elevation="0" v-bind="filteredAttrs" v-on="$listeners" :class="computedClass"
    :disabled="disabled">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    intent: String,
    small: Boolean,
    block: Boolean,
    disabled: Boolean,
  },
  default: {
    small: false,
    block: false,
    disabled: false,
  },
  computed: {
    filteredAttrs() {
      // eslint-disable-next-line
      const { class: _class, ...rest } = this.$attrs;
      return rest;
    },
    computedClass() {
      switch (this.intent) {
        case "link":
          return ["plusBlueDarken1--text plusGreyLighten3"];
        case "primary":
          return ["plus-btn-primary"];
        case "error":
          return ["plusRedDarken2", "white--text"];
      }
      return ["buttonDefault"];
    },
  },
};
</script>

<style scoped>
.buttonDefault {
  border: 1px solid rgba(0, 0, 0, 0.87);
}

/* Primary button — design system spec.
   Colors come from CSS custom properties generated by Vuetify (customProperties: true)
   so they automatically swap between light and dark themes without any JS conditional. */
.plus-btn-primary.v-btn:not(.v-btn--outlined):not(.v-btn--disabled) {
  background-color: var(--v-plusIndigoLighten1-base) !important;
  color: #ffffff !important;
  border: 1px solid var(--v-plusIndigoDarken1-base) !important;
}

.plus-btn-primary.v-btn:not(.v-btn--outlined):not(.v-btn--disabled):hover {
  background-color: var(--v-plusIndigoDarken1-base) !important;
}

.theme--light.plus-btn-primary.v-btn:not(.v-btn--outlined):not(.v-btn--disabled) {
  background-color: var(--v-plusIndigoDarken2-base) !important;
  border-color: var(--v-plusIndigoDarken3-base) !important;
}

.theme--light.plus-btn-primary.v-btn:not(.v-btn--outlined):not(.v-btn--disabled):hover {
  background-color: var(--v-plusIndigoDarken3-base) !important;
}

.plus-btn-primary.v-btn:not(.v-btn--outlined).v-btn--disabled {
  background-color: var(--v-plusGreyDarken3-base) !important;
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Outlined variant: keep the same color tokens but transparent background. */
.plus-btn-primary.v-btn--outlined:not(.v-btn--disabled) {
  border-color: var(--v-plusIndigoLighten1-base) !important;
  color: var(--v-plusIndigoLighten1-base) !important;
}

.plus-btn-primary.v-btn--outlined:not(.v-btn--disabled):hover {
  border-color: var(--v-plusIndigoDarken1-base) !important;
  color: var(--v-plusIndigoDarken1-base) !important;
}

/* Dark theme outlined: use a lighter indigo token for contrast against dark surfaces. */
.theme--dark.plus-btn-primary.v-btn--outlined:not(.v-btn--disabled) {
  border-color: var(--v-plusIndigoLighten2-base) !important;
  color: var(--v-plusIndigoLighten2-base) !important;
}

.theme--dark.plus-btn-primary.v-btn--outlined:not(.v-btn--disabled):hover {
  border-color: var(--v-plusIndigoLighten1-base) !important;
  color: var(--v-plusIndigoLighten1-base) !important;
}
</style>
